import { createFileRoute } from "@tanstack/react-router";
import { CatalogManager } from "@/components/feature/media/catalog-manager";
import { media, type AdTypeOut } from "@/lib/api";

export const Route = createFileRoute("/_auth/media/ad-types")({
  component: AdTypesPage,
});

function AdTypesPage() {
  return (
    <CatalogManager<AdTypeOut>
      title="Tipos de aviso"
      description="Catálogo editable de tipos de aviso. Los avisos existentes mantienen su tipo aunque desactives uno."
      queryKey={["media", "ad-types"]}
      list={() => media.listAdTypes({})}
      create={(body) => media.createAdType(body)}
      patch={(id, body) => media.patchAdType(id, body)}
      remove={(id) => media.deleteAdType(id)}
    />
  );
}
